import * as React from 'react';
import { isUserLoggedIn } from '@/redux/modules/user';
import { openSignUpModal } from '@/redux/modules/modal';
import { parseQueryParams, removeQueryParams, stringifyQuery } from '@/utils/queryParams';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { useHistory, useLocation } from 'react-router-dom';

type QueryParams = {
    action?: string;
};

const SignupAction = () => {
    const isLoggedIn = useAppSelector(isUserLoggedIn);
    const location = useLocation();
    const { push } = useHistory();
    const queryParams = parseQueryParams<QueryParams>(location.search);
    const dispatch = useAppDispatch();
    React.useEffect(() => {
        if (queryParams.action === 'signup') {
            const query = removeQueryParams(queryParams, ['action']);
            const stringified = stringifyQuery(query);
            const newLocation = location.pathname + stringified ? '?' + stringified : '';
            !isLoggedIn && dispatch(openSignUpModal());
            push(newLocation);
        }
    }, [dispatch, isLoggedIn, location, queryParams, push]);

    return null;
};

export default SignupAction;
